import {Component, Input, OnInit} from "@angular/core";
import {Barcode} from "../../model/barcode.interface";

@Component({
  selector: 'vb-barcode-list',
  templateUrl: './barcode-list.component.html',
  styleUrls: ['./barcode-list.component.css']
})
export class BarcodeListComponent implements OnInit {

  @Input() barcodes: Barcode[];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/identity/barcode/barcode-list/barcode-list.component.ts